import { HttpClient } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';

@Component({
  selector: 'atw-table-of-content-config',
  templateUrl: './table-of-content-config.component.html',
  styleUrls: ['./table-of-content-config.component.scss']
})
export class AtwTableOfContentConfig {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() blocks_of_page: any; // là dữ liệu blocks_of_page từ database

  isCollapsed: boolean = false;
  currentViewAll: any = {}; // biến xác định mở rộng tất cả hay theo thuộc tính
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình

  style_fields = [
    {
      title: 'dieu_chinh_bo_tron_chung',
      index: 1,
    },
    {
      title: 'dieu_chinh_bo_tron_theo_cap',
      index: 2,
    },
  ];

  /** Cấp được chọn để cấu hình */
  selectedLevel: number = 1;


  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    private vhEventMediator: VhEventMediator,
  ) { }


  ngOnInit() {
   
  }


  /**
   * Dùng để translate cho phần cấu hình Khoảng cách (margin)
   */
  translationMap: { [key: string]: string } = {
    top: 'ben_tren',
    right: 'ben_phai',
    bottom: 'ben_duoi',
    left: 'ben_trai'
  };
  /**
   * Lấy label tiếng việt của type.
   * @param type ví dụ: top, right, bottom, left
   * @returns label tiếng việt. Ví dụ: tren, phai, duoi, trai
   */
  getTranslatedLabel(type: string): string {
    return this.translationMap[type] || type;
  }


  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['table-of-content']['width'] = event.width + 'px';
    if (event.height) this.class['table-of-content']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass();
  }


  /* -------------------------------------------------------------------------------------------------------------------------------------- */
  /*                                                       CÁC HÀM UPDATE LÊN DATABASE                                                      */
  /* -------------------------------------------------------------------------------------------------------------------------------------- */

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        console.log('updateObject', bool);
      })
  }


  /**
   * Hàm update class vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        console.log('updateClass', bool);
      })
  }


  /**
   * Hàm update config vào database.
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {
        console.log('updateConfig', bool);
      })
  }


  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticdata() {
    // Gọi hàm truy vấn cơ sở dữ liệu ở đây
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
    .then((bool) => {
    });
  }


  /* -------------------------------------------------------------------------------------------------------------------------------------- */
  /*                                                        CÁC HÀM XỬ LÝ MENU CONFIG                                                       */
  /* -------------------------------------------------------------------------------------------------------------------------------------- */

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }


  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true, 
    menu2: false, 
    menu3: false, 
    menu4: false, 
    menu5: false, 
    menu6: false, 
    menu7: false, 
    menu8: false
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

}
